import env from "../env";
const TENANT_SERVER = env.REACT_APP_TENANT_URL;
const API_SERVER = TENANT_SERVER + "/cy";
export const API = {
  TENANT_REGISTER: TENANT_SERVER + "/tenant", // GET
  FEED: API_SERVER + "/api/feed", // GET
  AUTH: API_SERVER + "/api/user/login", // POST
  LOGOUT: API_SERVER + "/api/user/logout", // POST
  GET_ALL_USERS: API_SERVER + "/api/users", // GET
  GET_USER_APPLICATION_STATE: API_SERVER + "/api/userApplicationState", // GET
  CREATE_USER: API_SERVER + "/api/user", // POST
  GET_USER_BY_ID: API_SERVER + "/api/users", // GET By ID
  UPDATE_USER_BY_ID: API_SERVER + "/api/users", // PATCH By ID
  GET_USER_BY_CRD: API_SERVER + "/api/users/search", // GET By CRD
  GET_USER_BY_TOKEN: API_SERVER + "/api/users/invite", // GET By Token
  REQUEST_PASSWORD_RESET: API_SERVER + "/api/user/password/request-reset", // POST
  RESET_PASSWORD: API_SERVER + "/api/user/password/reset", // POST
  UPDATE_USER: API_SERVER + "/api/user", // PATCH user profiles
  USERS: API_SERVER + "/api/users", //
  UPDATE_USER_SETTINGS: API_SERVER + "/api/user/settings", // PATCH user settings
  VIDEO_WATCHED: API_SERVER + "/api/user/video", // PATCH
  ACKNOWLEDGE_TERMS: API_SERVER + "/api/user/acknowledge-terms", // PATCH
  CREATE_CLIENTS: API_SERVER + "/api/client", // POST
  UPDATE_CLIENTS: API_SERVER + "/api/client", // PATCH
  CREATE_PORTFOLIO: API_SERVER + "/api/household", // POST
  SAVE_PORTFOLIO_META: API_SERVER + "/api/portfolioMeta", // PATCH
  UPDATE_PORTFOLIO_STATUS: API_SERVER + "/api/portfolioStatus", // PATCH
  UPDATE_PORTFOLIO_NAME: API_SERVER + "/api/portfolioName", // PATCH
  GET_PORTFOLIO: API_SERVER + "/api/portfolio", // GET
  GET_PORTFOLIO_PDF: API_SERVER + "/api/portfolio/pdf", // GET
  POST_PORTFOLIO_PDF: API_SERVER + "/api/portfolio/pdf", // POST
  GET_PORTFOLIO_FOR_PRINT: API_SERVER + "/api/portfolioPrint", // GET
  GET_PORTFOLIO_HISTORY: API_SERVER + "/api/portfolio/history", // GET
  GET_CUSTOM_CONFIGURATION_BY_CLIENT_ID:
    API_SERVER + "/api/customConfiguration", // GET
  // DELETE_CLIENT: API_SERVER + '/api/portfolio', // DELETE
  GET_GENERAL_METRICS: API_SERVER + "/api/metrics/general", // GET
  GET_PORTFOLIO_SCENARIO_TOTALS: API_SERVER + "/api/portfolio/scenario-totals", // GET
  GET_BROKER_DEALERS: API_SERVER + "/api/broker-dealers", // GET
  GET_HOUSEHOLDS: API_SERVER + "/api/household", // GET
  CREATE_HOUSEHOLD: API_SERVER + "/api/household", // POST
  GET_HOUSEHOLD_BY_ID: API_SERVER + "/api/household", // GET
  DELETE_HOUSEHOLD_BY_ID: API_SERVER + "/api/household", // DELETE
  SAVE_HOUSEHOLD_META: API_SERVER + "/api/household", // PATCH
  GET_HOUSEHOLD_REPORTS_BY_ID: API_SERVER + "/api/report", // GET
  DOWNLOAD_REPORT: API_SERVER + "/api/report/download", // POST
  MULTI_ONBOARD: API_SERVER + "/api/portfolio/onboard", // POST
  STRATEGY_CHANGE_ONBOARD: API_SERVER + "/api/portfolio/onboardStrategyChange", // POST
  PORTFOLIO: API_SERVER + "/api/portfolio", // MULTI
  DEFAULT_PORTFOLIO: API_SERVER + "/api/defaultPortfolio", // MULTI
  DOWNLOAD_DISCLOSURE: API_SERVER + "/api/document/disclosure", //GET
  EMAIL_DISCLOSURE: API_SERVER + "/api/document/disclosure", // POST
  UPDATE_CUSTODIANS: API_SERVER + "/api/custodians/update", // POST
  REP_CODE: API_SERVER + "/api/repcode", // POST
  SEARCH_RELATED_ADVISORS: API_SERVER + "/api/repcode/getRelatedAdvisors", // post
  UPDATE_FEES_ADVISOR_CUSTODIAN: API_SERVER + "/api/fees/advisor/custodian", // POST
  UPDATE_FEES_ADVISOR_PLATFORM: API_SERVER + "/api/fees/advisor/platform", // POST
  UPDATE_FEES_ADVISOR_RATE: API_SERVER + "/api/fees/advisor/rate", // POST
  UPDATE_FEES_ADVISOR_RATE_DEFAULT:
    API_SERVER + "/api/fees/advisor/defaultRate", // POST
  UPDATE_FEES_ADVISOR_RATE_PORTFOLIO:
    API_SERVER + "/api/fees/advisor/portfolioRate", // POST
  UPDATE_FEES_DEFAULT_CUSTODIAN: API_SERVER + "/api/fees/custodian", // POST
  UPDATE_FEES_DEFAULT_PLATFORM: API_SERVER + "/api/fees/platform", // POST
  UPDATE_FEES_PLATFORM_DEFAULT: API_SERVER + "/api/fees/portfolio", // POST
  UPDATE_FEES_CUSTODIAN: API_SERVER + "/api/fees/advisor/removeCustodian", // POST
  JIRA: API_SERVER + "/api/jira", // get
  DOWNLOAD_CLIENT_EXPENSE: API_SERVER + "/api/document/clientExpense", //GET
  REDTAIL_LINK_ACCOUNT: API_SERVER + "/api/redtail/linkAccount", // POST
  REDTAIL_UNLINK_ACCOUNT: API_SERVER + "/api/redtail/unlinkAccount", // POST
  REDTAIL_SEARCH_FAMILIES: API_SERVER + "/api/redtail/families", // GET
  REDTAIL_IMPORT_FAMILY: API_SERVER + "/api/redtail/importFamily", // POST
  REDTAIL_IMPORT_FAMILIES: API_SERVER + "/api/redtail/importFamilies", // POST
  REDTAIL_LAST_IMPORT_JOB: API_SERVER + "/api/redtail/lastImportJob", // GET
  REDTAIL_RESET_PASSWORD: API_SERVER + "/api/redtail/resetpassword", // GET
  CPR_DATA: API_SERVER + '/api/cpr', // POST
  SINGLE_STRATEGIES: API_SERVER + '/api/cpr/singleStrategies', // GET
};

/*
 * REACT_APP_AZURE_INTERNAL_API_URL is used for the puppeteer page to call azure internal server
 */
const AZURE_INTERNAL_SERVER = env.REACT_APP_AZURE_INTERNAL_API_URL || "";
export const INTERNAL_API = {
  GET_PORTFOLIO_FOR_PRINT: AZURE_INTERNAL_SERVER + "/api/portfolioPrint", // GET
  GET_CUSTOM_CONFIGURATION_BY_CLIENT_ID:
    AZURE_INTERNAL_SERVER + "/api/customConfiguration", // GET
};



// WEBPACK FOOTER //
// ./src/utilities/api.config.js